module.exports = __webpack_public_path__ + "img/intro_6.6b8b22a.png";